import * as DeveloperConstant from "../Constants/DeveloperConstant";

export const hasSandboxAccount = (user) => {
    let sandboxAccount = false;
    if (user?.developer?.sandbox?.status) {
        sandboxAccount = user.developer.sandbox.status === "failed"? false: true
    }  
    return sandboxAccount;
}

export const getSandBoxStatus = (user) => {
    let status = DeveloperConstant.SandBoxState.NONE;
    if (!user) {
        return status;
    }

    if (user.developer?.sandbox?.status) {
        status = user.developer.sandbox.status;
    }
    return status;
}

export const isSandBoxAvailable = (user) => {
    return getSandBoxStatus(user) === DeveloperConstant.SandBoxState.SUCCESS;
}

export const getSandBoxTextUrl = (informations) => {
    let url = "";
    if (!informations) {
        return url;
    }

    if (informations.baseUrl) {
        url = informations.baseUrl;
    }
    return url;
}
